import styled from 'styled-components'
import PredictionTableBody from './PredictionTableBody'
import PredictionTableHead, { TableColumnType } from './PredictionTableHead'

interface PredictionTableProps<T> {
  tableColumns: TableColumnType<T>[]
  tableDataList: T[]
  className?: string
}

const PredictionTable = <T extends object>({
  tableColumns,
  tableDataList,
  className,
}: PredictionTableProps<T>) => {
  return (
    <StyledWrapper className={className}>
      <PredictionTableHead<T> tableColumns={tableColumns} />
      <PredictionTableBody
        tableDataList={tableDataList}
        tableColumns={tableColumns}
      />
    </StyledWrapper>
  )
}

export default PredictionTable

const StyledWrapper = styled.table`
  table-layout: fixed;
  width: 100%;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
`
